<template>
<div>
    <div class="devices" v-if="notloggedin">
      <div class="card-body">
        <validation-observer
          ref="observer"
        >
          <form @submit.prevent="submit" class="form">
            <validation-provider
              v-slot="{ errors }"
              name="Username"
              rules="required|min:5"
            >
              <v-text-field
                v-model="username"
                :error-messages="errors"
                label="Username"
                required
                solo dark
                autocomplete="off"
                color="whitesmoke"
              ></v-text-field>
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              name="Password"
              rules="required|min:8"
            >
              <v-text-field
                  v-model="password"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'"
                  :error-messages="errors"
                  label="Password"
                  class="input-group--focused"
                  @click:append="show = !show"
                  required
                  solo
                  dark 
              ></v-text-field>
            </validation-provider>

            <v-btn
              outlined rounded text dark class="foota"
              type="submit"
            >
              login
            </v-btn>
          </form>
        </validation-observer>
        <v-alert outlined type="error" text :value="invalidcredentials"> Invalid Credentials </v-alert>
      </div>
    </div>
</div>
</template>
<script>
  import { required, min } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import axios from "axios";

  setInteractionMode('eager')
  
  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })
  
  extend('min', {
    ...min,
    message: '{_field_} must have atlest {length} characters',
  })

  export default {
    name: 'Login',
    components: {
      ValidationProvider,
      ValidationObserver,
    },
    data: () => ({
      show: false,
      current_time: '',
      notloggedin: true,
      invalidcredentials: false,
    }),

    created () {
        this.checkloggedin();
    },

    methods: {
      submit () {
        if (this.username.length > 4 && this.password.length > 7) {
          let data = {
            username : this.username,
            password : this.password,
          };
          let config = {
            method : 'post',
            url : `https://kharame-devices.herokuapp.com/login`,
            data: data
          };
          axios(config)
          .then((response) => {
            if (response.data && response.data.access_token && response.data.status === "S") {
              sessionStorage.setItem("token", response.data.access_token)
              sessionStorage.setItem("data", JSON.stringify(response.data))
              sessionStorage.setItem("expire_time", response.data.expire_time)
              window.location.href = '/'
            }
          })
          .catch((error) => {
            this.invalidcredentials = true;
          })
        }
      },
      checkloggedin() {
        this.current_time = Math.round(+new Date()/1000);
        if (sessionStorage.getItem("token") && sessionStorage.getItem("expire_time") > this.current_time) {
          this.notloggedin= false;
          window.location.href = '/'
        } else {
          sessionStorage.clear();
        }
      },
    },
  }
</script>
<style scoped>
.devices {
  margin-top:8%;
  margin-bottom: 4%;
  margin-left: auto;
  margin-right: auto;
  width:50%;
  background: rgba(23,25,33,255) !important;
  box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6);
}
.devices1 {
  text-align: center;
  margin-top:8%;
  margin-bottom: 4%;
  margin-left: auto;
  margin-right: auto;
  width:85%;
}
.v-list-item__content .v-list-item__subtitle{
  color :whitesmoke !important;
  font-size: 14px;
  padding:1%;
}
.form {
  /* width:450px; */
  margin-left:auto;
  margin-right:auto;
  padding:5%;
  color:whitesmoke;
}
>>>.ql-align-center {
    text-align : center;
}
>>>.ql-align-right {
    text-align : right;
}

@media (max-width: 1000px) {
  .devices {
    width: 75%;
    margin-top: 10%;
    margin-bottom: 5%;
  }
}
@media (max-width: 550px) {
  .devices {
    width: 85%;
    display: block;
    margin-top: 18%;
    margin-bottom: 12%;
  }
}
</style>